import UAParser from 'ua-parser-js';
import { getPlayerConfiguration } from './player';

export const defaultHeaders = () => {
  const uaParser = new UAParser();
  const config = getPlayerConfiguration();
  return {
    'Client-Platform': config.clientPlatform.name,
    'Client-Platform-AppVersion': config.clientPlatform.version,
    'Client-Platform-Audience': config.clientPlatform.audience,
    'Client-Platform-Class': config.clientPlatform.class,
    'Client-Platform-OS-Version': uaParser.getOS().version || '',
    'Client-Platform-Model-Number': config.clientPlatform.class,
    'Client-Platform-Marketing-Name': uaParser.getDevice().model || '',
  } as HeadersInit;
};
